import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AuthInterceptor } from './auth/AuthInterceptor';
import { NavigationService } from './navigation/NavigationService';
// Network
// import { Api } from './network/Api';
import { ApiService } from './network/ApiService';
import { EffluentApi } from './network/endpoints/EffluentApi';
import { ExternalIdApi } from './network/endpoints/ExternalIdApi';
import { FarmApi } from './network/endpoints/FarmApi';
import { FieldApi } from './network/endpoints/FieldApi';
import { GeneralApi } from './network/endpoints/GeneralApi';
import { SoilApi } from './network/endpoints/SoilApi';
import { UserApi } from './network/endpoints/UserApi';
import { SharedService } from './shared/SharedService';

@NgModule({
  declarations: [],
  exports: [],
  imports: [],
  providers: [
    // Api,
    FarmApi,
    FieldApi,
    SoilApi,
    UserApi,
    GeneralApi,
    EffluentApi,
    ExternalIdApi,
    ApiService,
    SharedService,
    NavigationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppServicesModule {}
